import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Course, CourseRequest } from './CourseTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Course>>('/author/courses/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Course>(`/author/courses/${id}`).then(getData);
}

export function edit(id: Id, request: CourseRequest) {
  return axios.put<Course>(`/author/courses/${id}`, request).then(getData);
}

export function create(request: CourseRequest) {
  return axios.post<Course>(`/author/courses`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/courses/${id}`).then(getData);
}
